import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { PlayAlongBanner } from "@/components/PlayAlongPromo";
import { Button } from "@/components/ui/button";
import { WhyChoose, WhyYouTube } from "@/components/MarketingSections";

export default function WhyChoosePage() {
  return (
    <div className="min-h-screen text-foreground">
      <Navbar />
      <div className="border-b border-border">
        <div className="mx-auto grid max-w-7xl items-center gap-10 px-4 sm:px-8 py-14 lg:grid-cols-[1fr_340px] lg:py-16">
          <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-primary">Why The JT Hub</p>
          <h1 className="mt-3 font-serif text-4xl font-extrabold tracking-tight sm:text-5xl">A real teacher beats an algorithm.</h1>
          <p className="mt-4 max-w-2xl text-lg text-muted-foreground">Here's exactly why learners choose The JT Hub over piecing it together from free videos.</p>
          </div>
          <div className="overflow-hidden rounded-3xl border border-border shadow-2xl shadow-black/40">
            <img src="/media/jt-playing-4.webp" alt="Jason Thompson playing keys on stage" className="aspect-[4/5] w-full object-cover" data-testid="why-hero-image" />
          </div>
        </div>
      </div>
      <WhyChoose />
      <WhyYouTube />
      <div className="mx-auto max-w-7xl px-4 sm:px-8"><PlayAlongBanner testId="why-playalong-banner" /></div>
      <section className="mx-auto max-w-7xl px-4 sm:px-8 py-16">
        <div className="flex flex-col items-start justify-between gap-4 rounded-3xl border border-border bg-card p-8 sm:flex-row sm:items-center sm:p-10">
          <p className="font-serif text-2xl font-bold sm:text-3xl">See it for yourself in 10 lessons.</p>
          <div className="flex flex-col items-start gap-2 sm:items-center">
            <Link to="/courses" data-testid="whychoose-cta"><Button className="rounded-full bg-primary px-6 py-6 text-primary-foreground hover:bg-primary/90">Explore the courses <ArrowRight size={16} className="ml-2" /></Button></Link>
            <p className="text-sm font-semibold text-muted-foreground" data-testid="whychoose-cta-menu-hint">or click on the Menu tab for more information</p>
          </div>
        </div>
      </section>
    </div>
  );
}
